import {
  ColorsNeutral500,
  ColorsPrimary500,
  ColorsPrimary700,
  Dimensions2,
  Dimensions4,
  Dimensions6,
} from '@efexteam/design-tokens';
import { css } from '@emotion/css';

const wrapper = css({
  '&.MuiCard-root': {
    marginBottom: Dimensions4,

    '& .MuiTypography-caption': {
      color: ColorsNeutral500,
    },
  },
});

const content = css({
  '&.MuiCardContent-root': {
    paddingTop: '0',
  },
});

const contentItem = css({
  '&.MuiBox-root': {
    paddingTop: Dimensions6,
    paddingBottom: Dimensions6,

    '&:last-child': {
      paddingBottom: '0',
    },
  },
});

const contentItemRow = css({
  '&.MuiBox-root': {
    display: 'flex',
    paddingTop: Dimensions2,
    paddingBottom: Dimensions2,

    '& .MuiTypography-caption': {
      width: '30%',
    },

    '@media (max-width: 600px)': {
      flexDirection: 'column',
      gap: Dimensions4,

      '& .MuiTypography-caption': {
        width: '100%',
      },
    },
  },
});

const contentItemRowLink = css({
  '&.MuiTypography-root': {
    color: ColorsPrimary500,
    flex: 1,
    wordBreak: 'break-all',

    '&:hover': {
      color: ColorsPrimary700,
      textDecoration: 'underline',
    },
  },
});

const DetailCardStyles = {
  wrapper,
  content,
  contentItem,
  contentItemRow,
  contentItemRowLink,
};

export default DetailCardStyles;
